	export enum SerializedItemStatusEnum {
		InInventory = 1,
		OnTrial = 2,
		Returned = 3,
		DeliveredToPatient = 4,
		ReturnedToManufacturer = 5,
		PendingReturn = 6,
		RepairInShop = 7,
		Lost = 8,
		OwnedByPatient = 9,
		Dispensed = 10,
		Voided = 11
	}
